// import { usePageTitle } from '../hooks/usePageTitle';
// import { allBooksCategories } from "../data/CategoriesData"
import Cookies from 'js-cookie';
import Popup from 'reactjs-popup';
import Pagination from "../utilities/Pagination";
import RequestAddBook from "../features/library/RequestAddBook";
import LibrarySideList from "../features/library/components/LibrarySideList";
import SampleBook from "../assets/defaults/BookSample-1.png";
import ItemsToShow from "../components/common/ItemsToShow";

import { useState } from 'react';
import { Link } from "react-router-dom";
import { RiyalImgWHT } from "../components/common/RiyalImg";
import { useTranslation } from 'react-i18next';
import { useLibrary } from "../context/LibraryContext";
import { LibrarySearch } from "../components/search/Search";
import SortLibrary from '../components/sort/SortLibrary';
import formatTitleForUrl from '../utilities/formatTitleForUrl';
import { useLibCategory } from '../context/LibraryCategoryContext';
import { useMetadata } from "../hooks/useMetadata";

export default function MasarLibrary() {
    const [selectedBookId, setSelectedBookId] = useState("");
    const [sortState, setSortState] = useState("sortNone");
    const { t, i18n } = useTranslation();
    const { loading, selectedCategory, setSelectedCategory,
        libraryBooks, currentPage, setCurrentPage,
        searchQuery, setSearchQuery, setItemsLimit } = useLibrary();

    useMetadata(i18n.language);
    // usePageTitle('Library');
    const { libCategory } = useLibCategory();


    const handleChange = (event) => {
        setSelectedCategory(event.target.value);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    // const filteredBooksData = libraryBooks?.data?.result.filter(item =>
    //     item.title.includes(searchQuery) ||
    //     item.author.includes(searchQuery) ||
    //     item.publishedDate.toString().includes(searchQuery));

    const totalPages = libraryBooks?.data?.paginationInfo.totalPagesCount;
    const itemCount = libraryBooks?.data?.paginationInfo.totalCount;

    const sortNone = (a, b) => (a.title < b.title ? -1 : 1)
    const priceAscending = (a, b) => (a.price < b.price ? -1 : 1)
    const priceDescending = (a, b) => (a.price > b.price ? -1 : 1)

    if (!libraryBooks) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    if (loading) return <div className="text-center my-4 text-danger">{t("errorGetData")}</div>;

    return (
        <div className="container mt-4">
            <div className="d-flex flex-wrap flex-row flex-md-row align-items-center">
                <h3 className="c-darkOrange col-12 col-md-3">{t("Masar Library")}</h3>
                <LibrarySearch
                    searchQuery={searchQuery}
                    selectedCategory={selectedCategory}
                    libCategory={libCategory}
                    handleSearchChange={handleSearchChange}
                />
                <SortLibrary
                    setSortState={setSortState}
                    t={t}
                />
                <ItemsToShow
                    setItemsLimit={setItemsLimit}
                />
                {Cookies.get('token') ?
                    <Popup trigger={
                        <button className="btn btn-masar btn-light-beige col-8 col-md-1 mb-2 mx-auto">{t("AddBook")}</button>}
                        position="bottom left" modal>
                        <RequestAddBook />
                    </Popup> : ""}
            </div>
            <div className="d-flex flex-wrap justify-content-center">
                <LibrarySideList
                    libCategory={libCategory}
                    selectedCategory={selectedCategory}
                    selectedBookId={selectedBookId}
                    setSelectedCategory={setSelectedCategory}
                    setSelectedBookId={setSelectedBookId}
                    setCurrentPage={setCurrentPage}
                    itemCount={itemCount}
                    handleChange={handleChange}
                />
                <div className="d-flex flex-wrap flex-row align-content-start justify-content-center col-11 col-md-9 pt-1 ">
                    {/* if you want shuffle add it befor (searchQuery ... ) */}
                    {libraryBooks?.data?.result.length === 0 ?
                        (i18n.language === "ar" ?
                            <p className="text-center my-3 mx-auto rounded p-2 bg-light-gray w-75 c-darkBeige">نعمل على توفير كتب في هذا التصنيف قريبا</p> :
                            <p className="text-center my-3 mx-auto rounded p-2 bg-light-gray w-75 c-darkBeige">We hope to find book in this category soon</p>)
                        :
                        <>
                            {(libraryBooks?.data?.result).sort(
                                sortState === "sortNone" ? sortNone :
                                    (sortState === "priceAscending" ? priceAscending :
                                        (sortState === "priceDescending" ? priceDescending : ""))
                            )
                                .map((item) => (
                                    item.quantity > 0 ?
                                        <div
                                            key={item.id}
                                            className="book-container col-6 col-sm-4 col-xl-3 col-xxl-2 my-2 position-relative"
                                        // onClick={() =>
                                        //     navigate(`/${i18n.language}/masarLibrary/${item.id}/${formatTitleForUrl(item.title)}`)}
                                        >
                                            {sortState !== "sortNone" && <span className="text-white position-absolute top-25 end-0 badge rounded-pill bg-info">
                                                {item.price}  <RiyalImgWHT />
                                                <span className="visually-hidden">unread messages</span>
                                            </span>}
                                            <Link className="text-decoration-none text-black"
                                                to={`/${i18n.language}/masarLibrary/${item.id}/${formatTitleForUrl(item.title)}`}>
                                                <img
                                                    crossOrigin="anonymous"
                                                    // key={item.id}
                                                    // to remove (!) when image of book allowed //
                                                    src={item.thumbnail ? item.thumbnail : SampleBook}
                                                    alt={`book-id-${item.id}`}
                                                    className="rounded-2" />
                                                <div className="book-title p-1 rounded">
                                                    <p>{item.title}</p>
                                                </div>
                                            </Link>
                                        </div> : ""
                                ))}
                        </>}
                </div>
                <div className="col-4">
                    {totalPages > 1 &&
                        <Pagination
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            totalPages={totalPages} />
                    }
                </div>
            </div>
        </div>
    );
}
